import { useContext } from "react";

import { ILogger } from "./ILogger";
import { LoggerContext } from "./LoggerContext";

export function useLogger(): ILogger {
    return useContext(LoggerContext);
}
